import cloneDeep from 'lodash.clonedeep';
import { REFRESH } from '../types';
import { getTabByDirection } from '../../utils/crossMediaPlanTabsUtils';

export default (state, action) => {
  switch (action.type) {
    case 'SET_CURVES_GRAPH': {
      return {
        ...state,
        curvesGraph: action.payload,
      };
    }

    case 'SET_CROSS_STATE': {
      return {
        ...state,
        crossStates: {
          ...state.crossStates,
          [action.payload.key]: action.payload.value,
        },
      };
    }

    case 'SET_MEDIA_MIX_GRAPH': {
      return {
        ...state,
        mediaMixGraph: action.payload
          ? action.payload
          : cloneDeep(state.defaultContext.mediaMixGraph),
      };
    }

    case 'SET_PENETRATION': {
      // reset penetration state whenever audience/country is changed
      if (Object.keys(action.payload).length === 0) {
        return {
          ...state,
          penetration: {
            ...action.payload,
          },
        };
      } else {
        return {
          ...state,
          penetration: {
            ...state.penetration,
            ...action.payload,
          },
        };
      }
    }

    case 'SET_INDUSTRY_WEIGHTS': {
      return {
        ...state,
        industryWeights: action.payload,
      };
    }

    // case 'ADD_CUSTOM_MEDIA': {
    //   const newMedia = {
    //     ...action.payload,
    //     isCustomMedia: true,
    //   };
    //   return {
    //     ...state,
    //     medias: [...state.medias, newMedia],
    //   };
    // }
    //
    // case 'UPDATE_CUSTOM_MEDIA': {
    //   const updatedMedias = state.medias.map(media =>
    //     (media.name === action.payload.name && media.isCustomMedia) ? action.payload : media
    //   );
    //   return {
    //     ...state,
    //     medias: updatedMedias,
    //   };
    // }

    case 'SET_MEDIAS': {
      return {
        ...state,
        medias: action.payload,
      };
    }

    case 'SET_MEDIAS_DEFAULT': {
      return {
        ...state,
        defaultContext: {
          ...state.defaultContext,
          medias: {
            ...state.defaultContext.medias,
            [action.payload.publisher]: cloneDeep(action.payload.medias),
          },
        },
      };
    }

    case 'SET_PUBLISHER': {
      return { ...state, publisher: action.payload };
    }

    case 'SET_PUBLISHERS': {
      return {
        ...state,
        publishers: action.payload,
      };
    }

    case 'SET_MMMS': {
      return {
        ...state,
        MMMs: action.payload,
      };
    }

    case 'SET_DMAS': {
      return {
        ...state,
        DMAs: action.payload,
      };
    }

    case 'SET_MMMS_DEFAULT': {
      return {
        ...state,
        defaultContext: {
          ...state.defaultContext,
          MMMs: cloneDeep(action.payload),
        },
      };
    }

    case 'SET_DMAS_DEFAULT': {
      return {
        ...state,
        defaultContext: {
          ...state.defaultContext,
          DMAs: cloneDeep(action.payload),
        },
      };
    }

    case 'SET_CONTEXT': {
      return {
        ...state,
        ...action.payload,
      };
    }

    case 'DELETE_TAB': {
      if (state.selectedTab === action.payload) {
        state.selectedTab = state.previousTab;
      } else if (state.previousTab === action.payload) {
        state.previousTab = false;
        let excluded = [state.previousTab, state.selectedTab, action.payload];
        for (const tab of Object.values(state.tabs))
          if (!excluded.includes(tab.index)) state.previousTab = tab.index;
      }
      delete state.tabs[action.payload];
      return {
        ...state,
        tabs: {
          ...state.tabs,
        },
      };
    }

    case 'PUSH_TAB': {
      return {
        ...state,
        tabs: { ...state.tabs, [action.payload.index]: action.payload },
      };
    }

    case 'RESTORE_SELECT_TAB_TO_CONTEXT': {
      return {
        ...state,
        ...cloneDeep(state.tabs[state.selectedTab].context),
      };
    }

    case 'STORE_CONTEXT_TO_TAB': {
      state.tabs[state.selectedTab].context = {};
      for (const key of Object.keys(state.defaultContext))
        state.tabs[state.selectedTab].context[key] = state[key];

      return {
        ...state,
        ...cloneDeep(state.tabs[state.selectedTab].context),
        crossStates: cloneDeep(state.defaultCrossStates),
      };
    }

    case 'STORE_CONTEXT_TO_NEW_TAB': {
      // load context from previous tab to new campaign tab when creating
      // from template.
      return {
        ...state,
        ...cloneDeep(state.tabs[state.previousTab].context),
      };
    }

    case 'SWITCH_TAB': {
      // saving campaign
      if (state.selectedTab === action.payload) {
        // tab update -- reset crossStates
        return {
          ...state,
          crossStates: cloneDeep(state.defaultCrossStates),
        };
      }

      if (state.selectedTab) {
        // store current context before switching
        state.tabs[state.selectedTab].context = {};
        for (const key of Object.keys(state.defaultContext))
          state.tabs[state.selectedTab].context[key] = state[key];
      }

      // find next best tab to use in case a previous tab is not available
      // eg: deleting multiple tabs in a row, adding a new tab from none, etc.
      let nextBestTab = false;
      let excluded = [state.previousTab, state.selectedTab, action.payload];
      for (const tab of Object.values(state.tabs))
        if (!excluded.includes(tab.index)) nextBestTab = tab.index;

      // prepare context to load
      let context;
      if (action.payload && state.tabs[action.payload]) {
        // switch to existing tab, load context from tab
        context = state.tabs[action.payload].context;
      } else {
        // switch to new tab, load default context and inserted correct publisher's medias
        context = cloneDeep(state.defaultContext);
        context.medias = context.medias[context.selectedData];
      }

      return {
        ...state,
        previousTab: state.selectedTab || nextBestTab,
        selectedTab: action.payload,
        ...context,
      };
    }

    case 'SET_SELECTED_DATA': {
      return {
        ...state,
        selectedData: action.payload,
      };
    }

    case REFRESH: {
      return action.payload;
    }

    case 'MOVE_TAB_TO': {
      const { id, direction } = action.payload;

      const neighborTab = getTabByDirection(id, state.tabs, direction);

      if (neighborTab) {
        return {
          ...state,
          tabs: {
            ...state.tabs,
            [neighborTab.index]: {
              ...state.tabs[id],
              index: neighborTab.index,
            },
            [id]: {
              ...state.tabs[neighborTab.index],
              index: id,
            },
          },
        };
      }
      return state;
    }

    case 'SET_PRESET': {
      return { ...state, preset: action.payload };
    }

    case 'SET_PRESETS': {
      return { ...state, presets: action.payload };
    }

    case 'SET_WORKFLOW_ID': {
      return { ...state, workflowId: action.payload };
    }

    case 'SET_TAB_WORKFLOW_ID': {
      return { ...state, tabWorkflowId: action.payload };
    }

    case 'CLEAR_WORKFLOW_ID': {
      return { ...state, workflowId: null };
    }

    case 'CLEAR_TAB_WORKFLOW_ID': {
      return { ...state, tabWorkflowId: null };
    }

    default:
      return state;
  }
};
